// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__maytra_3d1056', '__maytra_Fallback_3d1056'"},"className":"__className_3d1056"};